import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";
import { getAscents, getProblems, toggleStar, postTicks } from '../utils/api';
import Loading from './loading';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import { deepOrange, deepPurple, green } from '@mui/material/colors';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ProblemViewer from './problem-viewer';
import TickModal from './tick-modal';
import TickListModal from './tick-list-modal';

const Ascents = () => {
  let { userId } = useParams();
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const { isAuthenticated, isLoading, getAccessTokenSilently, loginWithRedirect } = useAuth0();
  const [ascents, setAscents] = useState(null);
  const [showProblem, setShowProblem] = useState(null);
  const [showTickModal, setShowTickModal] = useState(false);
  const [showTickListModal, setShowTickListModal] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      getAccessTokenSilently().then((token) => setAccessToken(token));
    }
  }, [getAccessTokenSilently, isAuthenticated]);

  useEffect(() => {
    const uid = userId ? parseInt(userId) : 0;
    getAscents(accessToken, uid).then((res) => {
      setAscents(res);
    });
  }, [accessToken, userId]);

  const getGradeColor = (grade) => {
    if (grade.startsWith('6')) return deepOrange[500];
    if (grade.startsWith('7')) return deepPurple[500];
    if (grade.startsWith('8')) return green[500];
    return undefined;
  };

  if (isLoading || !ascents) {
    return <Loading/>
  }

  return (
    <>
      <TickModal
        open={showTickModal}
        p={showProblem}
        onClose={(p) => {
          setShowTickModal(false);
          setShowProblem(p);
          getAscents(accessToken, userId ? parseInt(userId) : 0).then((res) => {
            setAscents(res);
          });
        }}
        accessToken={accessToken}
        isAuthenticated={isAuthenticated}
        loginWithRedirect={loginWithRedirect}
      />
      <TickListModal
        open={showTickListModal}
        p={showProblem}
        onClose={() => setShowTickListModal(false)}/>
      {showProblem &&
        <ProblemViewer
          p={showProblem}
          openTickModal={() => setShowTickModal(true)}
          openTickListModal={() => setShowTickListModal(true)}
          toggleStar={() => {
            toggleStar(accessToken, showProblem.id)
            .then(() => {
              let p = ascents.filter(x => x.problemId === showProblem.id)[0];
              p.star = !p.star;
              setAscents([...ascents]);
              setShowProblem(null);
            })
            .catch((error) => {
              console.warn(error);
              alert(error.toString());
            });
          }}
          closeShowProblem={() => setShowProblem(null)}
          accessToken={accessToken}
          isAuthenticated={isAuthenticated}
          loginWithRedirect={loginWithRedirect}
          />
      }
      
      <Box sx={{ overflow: 'auto' }}>
        <List dense={true}>
          {ascents.map(a => {
            let primary;
            let secondary;
            if (parseInt(userId || "0") == 0) {
              primary = "#" + a.nr + " " + a.type + " " + a.wall + " by " + a.problemCreator;
              secondary = a.created;
            } else {
              var stars = "\u2606\u2606\u2606";
              if (a.problemStars===1.0) {
                stars = "\u2605\u2606\u2606";
              } else if (a.problemStars===2.0) {
                stars = "\u2605\u2605\u2606";
              } else if (a.problemStars===3.0) {
                stars = "\u2605\u2605\u2605";
              }
              primary = a.user + " ticked #" + a.nr + " " + a.type + " " + a.wall;
              secondary= a.timeAgo + " " + stars + " " + a.problemTicks + " ascent(s) by " + a.problemCreator;
            }
            
            const avatarColor = getGradeColor(a.grade);

            return (
              <ListItem 
                key={a.id} 
                disablePadding
                secondaryAction={
                  a.isMine && (
                    <IconButton edge="end" aria-label="delete" onClick={() => {
                        if (confirm("Delete ascent?")) {
                          console.log(a)
                          postTicks(accessToken, a.id, a.problemId, -1, null)
                            .then(() => {
                              getAscents(accessToken, parseInt(userId || "0")).then((res) => {
                                setAscents(res);
                              });
                            })
                            .catch((error) => {
                              console.warn(error);
                              alert(error.toString());
                            });
                        }
                      }}>
                      <DeleteIcon />
                    </IconButton>
                  )
                }
              >
                <ListItemButton 
                  dense 
                  onClick={() => {
                    getProblems(accessToken, a.problemId)
                      .then((data) => setShowProblem(data[0]))
                      .catch((error) => {
                        console.warn(error);
                        alert(error.toString());
                      });
                  }}
                >
                  <Avatar 
                    sx={{ 
                      bgcolor: avatarColor, 
                      color: '#fff', 
                      marginRight: '10px' 
                    }} 
                    alt={a.grade}
                  >
                    {a.grade}
                  </Avatar>
                  
                  <ListItemText
                    primary={primary}
                    secondary={secondary} />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </>
  )
}

export default Ascents;